module.exports = __webpack_public_path__ + "img/d2sj-btn.175714dd.png";